'use strict';

import accordion from 'plugins/accordion';

export default function () {
    const elements = document.querySelectorAll('.js-accordion');

    if (!elements.length) {
        return false;
    }

    elements.forEach(element => {
        accordion(element);
    });

    // Scroll to and open item if the ID is in the URL.
    const openItem = anchor => {
        if (!anchor) return;
        const detail = document.querySelector(`details[id="${anchor.replace(/^#/, '')}"]`);
        if (!detail) return;
        const handle = detail.querySelector('.accordion__handle');
        if (handle) {
            handle.click();
        }
        detail.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    setTimeout(() => openItem(window.location.hash), 100);
    window.addEventListener('hashchange', () => openItem(window.location.hash));

    const nextSelectors = document.querySelectorAll('[data-donation-accordion-next-selector]');

    nextSelectors.forEach(selector => {
        selector.addEventListener('click', event => {
            const nextSelector = event
                .currentTarget
                .dataset

            if (!nextSelector) {
                return;
            }

            const nextElement = document.querySelector(nextSelector);

            if (!nextElement) {
                return;
            }

            nextElement.click();
        }, false);
    });
}
